import React, { useEffect, useState } from 'react';
import { motion, useReducedMotion } from 'framer-motion';

import { AppWrap, MotionWrap } from '../../wrapper';
import { client } from '../../client';
import './Education.scss';

const Education = () => {
  const [education, setEducation] = useState([]);
  const [error, setError] = useState('');
  const reduceMotion = useReducedMotion();

  useEffect(() => {
    const query = '*[_type == "education"] | order(passingYear desc)';

    client.fetch(query)
      .then(setEducation)
      .catch(() => setError('Education details could not be loaded right now.'));
  }, []);

  return (
    <>
      <div className="education-heading">
        <div>
          <p className="eyebrow">04 / Education</p>
          <h2 className="head-text">A technical foundation, <span>built to evolve.</span></h2>
        </div>
        <p>
          A computer science foundation that led from an undergraduate image
          classification thesis to professional product engineering.
        </p>
      </div>

      {error && <p className="status-message status-message--error" role="status">{error}</p>}

      <div className="education-list">
        {education.flatMap((item) => (
          (item.details || []).map((detail, index) => (
            <motion.article
              className="education-item"
              key={detail._key || `${item._id}-${index}`}
              initial={reduceMotion ? false : { opacity: 0, x: -24 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, amount: 0.45 }}
              transition={{ duration: 0.55, delay: reduceMotion ? 0 : index * 0.08 }}
            >
              <p className="education-year">{item.passingYear}</p>
              <div>
                <h3>{detail.degree}</h3>
                <p>{detail.institution}</p>
                {detail.desc && <p className="education-description">{detail.desc}</p>}
              </div>
              <span className="education-mark" aria-hidden="true">↗</span>
            </motion.article>
          ))
        ))}
      </div>
    </>
  );
};

export default AppWrap(
  MotionWrap(Education, 'app__education'),
  'education',
  'app__whitebg',
);
